<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShuffle_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m8.872 1.966 2.792.912L1.58 12.673a.943.943 0 0 0 0 1.363 1.011 1.011 0 0 0 1.402 0L13.066 4.24l.938 2.712c.08.232.325.373.567.333a.5.5 0 0 0 .43-.49V1.496A.503.503 0 0 0 14.488 1H9.035a.508.508 0 0 0-.505.416c-.04.24.104.473.342.55Zm5.133 7.08-.938 2.713-2.835-2.754a1.011 1.011 0 0 0-1.402 0 .943.943 0 0 0 0 1.362l2.835 2.754-2.792.912a.497.497 0 0 0-.342.55c.04.242.254.417.503.417h5.455c.283 0 .51-.222.51-.496v-5.3a.502.502 0 0 0-.428-.49.512.512 0 0 0-.566.333ZM1.287 1.686a.944.944 0 0 0 .007 1.362l3.93 3.778c.39.374 1.018.371 1.403-.007a.944.944 0 0 0-.007-1.363L2.69 1.677a1.012 1.012 0 0 0-1.403.008Z"
        clip-rule="evenodd"
    />
</svg>
